import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from "react";
import { cx } from "../lib/cx.js";
import { Button } from "./Button.js";
import { IconButton } from "./Menu.js";
import { Icon } from "../icons/Icon.js";
export function Modal({ open, title, children, onClose, footer, size = "md", }) {
    const ref = useRef(null);
    const lastFocus = useRef(null);
    const titleId = useId();
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (open) {
            lastFocus.current = document.activeElement;
            if (!el.open)
                el.showModal();
            const focusable = el.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            (focusable ?? el).focus();
        }
        else if (el.open) {
            el.close();
            lastFocus.current?.focus();
        }
    }, [open]);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const onCancel = (e) => {
            e.preventDefault();
            onClose();
        };
        el.addEventListener("cancel", onCancel);
        return () => el.removeEventListener("cancel", onCancel);
    }, [onClose]);
    return (_jsxs("dialog", { ref: ref, className: cx("evolua-modal", `evolua-modal--${size}`), "aria-labelledby": titleId, "aria-modal": "true", onClose: onClose, children: [_jsxs("div", { className: "evolua-modal__header", children: [_jsx("h2", { id: titleId, className: "evolua-modal__title", children: title }), _jsx(IconButton, { label: "Fechar", onClick: onClose, children: _jsx(Icon, { name: "close", size: 16 }) })] }), _jsx("div", { className: "evolua-modal__body", children: children }), _jsx("div", { className: "evolua-modal__footer", children: footer ?? (_jsx(Button, { variant: "secondary", onClick: onClose, children: "Fechar" })) })] }));
}
//# sourceMappingURL=Modal.js.map